module.exports = __webpack_public_path__ + "img/shipinhao.b4a73ceb.png";